// NAQT考试
export default [
  {
    path: '/RoomInfo',
    name: 'RoomInfo',
    // meta: {
    //   IndexHeader: true,
    //   itemIndex: -1
    // },
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/')
  },
  // 我得房间
  {
    path: '/MyRoomList',
    name: 'MyRoomList',
    // meta: {
    //   IndexHeader: true,
    //   itemIndex: -1
    // },
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/my-roomlist')
  },
  // 加入房间
  {
    path: '/JoinRoom',
    name: 'JoinRoom',
    // meta: {
    // IndexHeader: true,
    //   itemIndex: -1
    // },
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/room-list')
  },
  // 抢答房间（学生）
  {
    path: '/AnswerRoom',
    name: 'AnswerRoom',
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/answer-room')
  },
  // 抢答房间（主持人）
  {
    path: '/QuestionRoom',
    name: 'QuestionRoom',
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/question-room')
  },
  // 结束页面
  {
    path: '/NaqtEnd',
    name: 'NaqtEnd',
    component: () =>
    import(/* webpackChunkName: "Room" */ '@/components/sub-task/room/score-report')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/bloom-room.js